module.exports = __webpack_public_path__ + "media/scholarship_winners/sang-sw-1ae18fb9.png";